import { DelegationIdentity, Ed25519KeyIdentity } from '@icp-sdk/core/identity'
import { Secp256k1KeyIdentity } from '@icp-sdk/core/identity/secp256k1'
import { Principal } from '@icp-sdk/core/principal'
import Wallet from '../wallet'

export enum KeychainType {
  HDKeychain = 'HDKeychain',
  KeyPairKeychain = 'KeyPairKeychain',
  DelegationKeychain = 'DelegationKeychain',
}

export interface IKeyChain {
  type: string
  serialize(): Promise<unknown>
  deserialize(options: unknown): Promise<void>
  addNewAccount(): Promise<Array<Wallet>>
  getPrincipals(): Promise<Principal[]>
  getIdentity(
    principal: string
  ): Promise<Secp256k1KeyIdentity | Ed25519KeyIdentity | DelegationIdentity>
  exportKeychain(): Promise<string>
  exportPem(principal: string): Promise<string>
  clear(): void
}
